import React from "react";
import styled from "styled-components";
import { grey } from "@material-ui/core/colors";

const SelectSkeleton = styled.div`
  width: 100%;
  height: 75%;
  background-color: ${grey[300]};
  border-radius: 5px;
  margin: 0 10px;
`;

const ButtonSkeleton = styled.div`
  width: 100%;
  height: 75%;
  background-color: ${grey[500]};
  border-radius: 5px;
`;

const YMMTFormSkeleton = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
`;

export default () => (
  <YMMTFormSkeleton>
    <SelectSkeleton />
    <SelectSkeleton />
    <SelectSkeleton />
    <SelectSkeleton />
    <ButtonSkeleton />
  </YMMTFormSkeleton>
);
